import { useState } from 'react';

export default function NewsletterSection() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [errorMsg, setErrorMsg] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const form = e.currentTarget;
    const honeypot = (form.elements.namedItem('phone_alt') as HTMLInputElement)?.value?.trim();
    if (honeypot) {
      setStatus('success');
      setEmail('');
      return;
    }

    try {
      const formData = new FormData(form);
      const res = await fetch('https://readdy.ai/api/form/d9slhnh4ne17ei0sdjbg', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await res.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }

      if (res.ok && parsed?.code === 'OK') {
        setStatus('success');
        setEmail('');
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText;
        setStatus('error');
        setErrorMsg(serverMsg || '订阅失败，请稍后重试');
      }
    } catch {
      setStatus('error');
      setErrorMsg('网络错误，请检查网络连接后重试');
    }
  };

  return (
    <section className="py-16 md:py-24 px-4 md:px-6 relative overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Soft%20elegant%20cat%20silhouette%20with%20warm%20cream%20background%2C%20abstract%20artistic%20composition%2C%20minimalist%20style%2C%20gentle%20textures%2C%20subtle%20gradient%2C%20peaceful%20atmosphere&width=1920&height=600&seq=newsletter-bg&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-background-950/70 via-background-950/50 to-background-950/70" />
      <div className="relative z-10 max-w-2xl mx-auto text-center">
        <p className="font-accent text-base italic text-primary-400 mb-3 tracking-wider">
          Stay Inspired
        </p>
        <h2 className="text-2xl md:text-3xl font-heading font-semibold text-background-50 mb-3">
          订阅喵绅士资讯
        </h2>
        <p className="text-sm md:text-base text-background-300 mb-8 leading-relaxed">
          每周精选猫咪文化与精致生活内容，直接送达您的邮箱。优雅从不缺席。
        </p>

        {status === 'success' ? (
          <div className="bg-background-50/10 backdrop-blur-sm rounded-lg p-6 border border-background-50/20">
            <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-primary-500/20 flex items-center justify-center">
              <i className="ri-check-line text-primary-400 text-xl w-6 h-6 flex items-center justify-center" />
            </div>
            <p className="text-background-50 font-medium">感谢订阅！</p>
            <p className="text-sm text-background-400 mt-1">欢迎加入喵绅士的优雅世界</p>
          </div>
        ) : (
          <form
            onSubmit={handleSubmit}
            data-readdy-form
            className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto"
          >
            <input
              type="text"
              name="phone_alt"
              tabIndex={-1}
              autoComplete="off"
              aria-hidden="true"
              readOnly
              className="honeypot-field"
            />
            <input
              type="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="请输入您的邮箱地址"
              className="flex-1 px-4 py-3 bg-background-50/10 backdrop-blur-sm border border-background-50/20 rounded-full text-sm text-background-50 placeholder:text-background-400 focus:outline-none focus:border-primary-400 transition-colors"
            />
            <button
              type="submit"
              className="px-6 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-all duration-300 whitespace-nowrap"
            >
              立即订阅
            </button>
          </form>
        )}

        {status === 'error' && (
          <p className="text-sm text-red-400 mt-3">{errorMsg}</p>
        )}

        <p className="text-xs text-background-500 mt-4">
          我们尊重您的隐私，绝不发送垃圾邮件。您可以随时取消订阅。
        </p>
      </div>
    </section>
  );
}